/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
// import './NotFound.scss';

/**
 * This is the NotFound component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function NotFound() {
  return (
    <article className="page not-found">
      <h2>404 Siden finnes ikke</h2>
    </article>
  );
}

export default NotFound;
